var firebase = require('firebase/app');
require('firebase/auth');
require('firebase/database');
require('firebase/storage');
require('firebase/functions');

const devConfig = {
  apiKey: 'AIzaSyDGZwot7yxDhdP6xmThIRhbuQiIBSAFLFg',
  authDomain: 'sonad.firebaseapp.com',
  databaseURL: 'https://sonad.firebaseio.com',
  projectId: 'firebase-sonad',
  storageBucket: 'firebase-sonad.appspot.com',
  messagingSenderId: '705729180028',
};

const prodConfig = {
  apiKey: 'AIzaSyDGZwot7yxDhdP6xmThIRhbuQiIBSAFLFg',
  authDomain: 'sonad.firebaseapp.com',
  databaseURL: 'https://sonad.firebaseio.com',
  projectId: 'firebase-sonad',
  storageBucket: 'firebase-sonad.appspot.com',
  messagingSenderId: '705729180028',
};

const config = process.env.NODE_ENV === 'production' ? prodConfig : devConfig;

class Firebase {
  constructor() {
    firebase.initializeApp(config);

    this.auth = firebase.auth();
    this.db = firebase.database();
    this.storage = firebase.storage();
    this.functions = firebase.functions();
    this.storage_media_bucket = firebase.app().storage("gs://sonad-media");
  }

  // *** Auth API ***
  doCreateUserWithEmailAndPassword = (email, password) =>
    this.auth.createUserWithEmailAndPassword(email, password);

  doSignInWithEmailAndPassword = (email, password) =>
    this.auth.signInWithEmailAndPassword(email, password)

  doSignOut = () => this.auth.signOut();

  doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

  doPasswordUpdate = password => this.auth.currentUser.updatePassword(password);

  doSendEmailVerification = () => this.auth.currentUser.sendEmailVerification();

  // *** User API ***
  user = uid => this.db.ref(`users/${uid}`);

  user_by_email = email => this.db.ref(`users`).orderByChild('email').equalTo(email).limitToFirst(1).ref;

  users = () => this.db.ref('users');

  email_verified = () => {
    let cu = this.auth.currentUser
    return (cu != null && cu.emailVerified) ? cu.email : null
  }

  auth_user = () => this.auth.currentUser

  get_uid = () => {
    let cu = this.auth.currentUser
    if (cu != null) return cu.uid
  }

  // *** Sona API ***
  sona = sona_id => this.db.ref(`Item/${sona_id}`);

  sona_by_code = sona_code => {
    return this.db.ref(`Item`).orderByChild('code').equalTo(sona_code)
  }

  sona_analytics = sona_id => this.db.ref(`Analytics/${sona_id}`);

  sonas = () => this.db.ref('Item');
}

export default Firebase;
